import {useCallback, useEffect, useState} from 'react';
import axiosInstance from "../../../../../axiosInstance";

const useGetProducts = ({projectId, page, size, favorite}) => {
  const [data, setData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(true);

  const removeData = useCallback(({productId}) => {
    const baseUrl = window.localStorage.getItem("BaseURL")
    const endpoint = `/services/projectmanagement/api/products/${productId}`
    const fullUrl = baseUrl + endpoint;

    return new Promise((resolve, reject) => {
      axiosInstance
        .delete(fullUrl)
        .then((res) => {
          setData(prevData => prevData.filter(item => item.id !== productId));
          resolve(res.data);
        })
        .catch(reject)
    })
  }, [])

  const getData = useCallback(({projectId, favorite, page, size}, refresh = false) => {
    setLoading(true)
    const baseUrl = window.localStorage.getItem("BaseURL")
    const endpoint = "/services/projectmanagement/api/products"
    const fullUrl = baseUrl + endpoint;

    return new Promise((resolve, reject) => {
      axiosInstance
        .get(fullUrl, {
          params: {
            'jobStatus.equals': 'COMPLETED',
            sort:'createdDate,desc',
            'projectId.equals': projectId,
            ...favorite ? {'favorite.equals': favorite} : undefined,
            page,
            size,
          }
        })
        .then((res) => {
          setTotalData(res.headers['x-total-count'])
          if (refresh) {
            setData(res.data);
          } else {
            setData(prev => ([
              ...prev,
              ...res.data
            ]));
          }
          resolve(res.data)
        })
        .catch(reject)
        .finally(() => {
          setLoading(false)
        });
    })
  }, []);

  useEffect(() => {
    const shouldRefresh = page < 1;
    getData({projectId, favorite, page, size}, shouldRefresh)
      .catch(console.error);
  }, [favorite, getData, page, projectId, size])

  return {data, loading, getData, removeData, totalData};
};

export default useGetProducts;
